import { render, staticRenderFns } from "./auctionRule.vue?vue&type=template&id=21f38a1d&scoped=true"
var script = {}
import style0 from "./auctionRule.vue?vue&type=style&index=0&id=21f38a1d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21f38a1d",
  null
  
)

export default component.exports